import styled, { css } from 'styled-components'

import { themeStyles } from '../../../styles/theme'

const gapSpacing = '1em'

// Slide width is calculated by dividing 100 width the length number, this way we divide the entire StyledSlidesWrapper in even segments
// Then we subtract a few ems so it doesnt take the full segment
const calculateSlideWidth = ({ length }) => `${100 / length}%`

// Transform position is calculated by taking the width of a slide, adding some ems (because of the gap) and then multplying it with the index
// We need the index to be a negative number so that the position goes backwards
// Lastly we the gap ems again IF its the last slide
const calculateTransformPosition = ({ length, index }) => {
  return css`
  translate3d(
    calc(calc(${calculateSlideWidth} + ${
      parseInt(gapSpacing) / length
    }em) * ${-index}),
    0,
    0
  )`
}

export const StyledDesktopCarouselWrapper = styled.section`
  display: flex;
  flex-direction: column;

  width: 100%;
  position: relative;
  background-color: ${themeStyles.colors.black.main};
`

export const StyledSlidesWrapper = styled.div`
  transition-duration: 500ms;
  position: relative;
  display: flex;
  gap: ${gapSpacing};

  width: calc(
    ${(props) => 100 * props.length}% +
      ${(props) => parseInt(gapSpacing) * (props.length - 1)}em
  );
  transform: ${calculateTransformPosition};

  overflow: hidden;
`

export const StyledSlide = styled.div`
  display: flex;
  text-align: left;
  padding: 0;
  color: ${themeStyles.colors.white.main};
  border-radius: 8px;
  overflow: hidden;
  opacity: ${(props) => (props.isShown ? 1 : 0.4)};
  transition: 0.5s opacity;
  height: 300px;
  width: ${calculateSlideWidth};
  background-color: ${(props) => props.backgroundColor};

  //? The following lines are needed because
  //? otherwise overflow doesnt work on safari
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  transform: translate3d(0, 0, 0);

  img,
  picture {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  picture {
    max-width: 60%;
    overflow: visible;
  }
`

export const WaveImageContainer = styled.div`
  width: 100%;
`

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 1em 0em 1em 1em;
  box-sizing: border-box;
  min-width: 45%;
  position: relative;

  ${({ useGatsbyImage }) =>
    useGatsbyImage &&
    css`
      position: relative;
      z-index: 1;
    `}

  a,
  button {
    margin-top: auto;
  }
`
